<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="user_is_load" parent="user">
    <tab id="info" :name="translate('user.section.info')" :href="url+'/info'">
      <Info v-if="user_is_load"
        :main_info="user_info"
        @update="get_user"
      />
    </tab>

    <tab id="groups" :name="translate('user.section.groups')" :href="url+'/groups'">
      <Groups
        :user_info="user_info"
        @update_device_groups="update_device_groups"
      />
    </tab>

    <tab id="role_manager" :name="translate('user.section.role_manager')" :href="url+'/role_manager'">
      <RoleManager
        :user_id="user_info.id"
        @update="get_user"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              User: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/user_management/users'}">
              To User list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Index.vue'
import Groups from './Tabs/Groups/Index.vue'
import RoleManager from './Tabs/RoleManager/Index.vue'

export default {
  name: 'User',
  components: {
    Info,
    Groups,
    RoleManager,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      user_info: null,
    }
  },

  computed: {
    url () { return '/user/' + this.$route.params.user_id },
    cur_id () { return this.$route.params.user_id },
    load () { return !this.user_info?.id },
    user_is_load() { return this.user_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'user_section') {
        this.get_user()
      }
    }
  },

  activated(){
    this.get_user()
  },

  methods: {
    update_device_groups(user_device_groups){
      this.user_info.user_device_groups = user_device_groups
      this.$emit('update')
    },
    get_user () {
      if (isNaN(Number(this.$route.params.user_id))){
        this.$http.v1.getUserInfoByNick(this.$route.params.user_id, (response) => {
          this.user_info = response.data
          this.$store.commit('updateSelectedUser', response.data)
        })
      }else{
        this.$http.v1.getUserInfo(this.$route.params.user_id, (response) => {
          this.user_info = response.data
          this.$store.commit('updateSelectedUser', response.data)
        })
      }
    }
  }
}

</script>
